import { createUseMutation } from 'api/common/createUseMutation'
import { postFavouritePractitioner } from 'api/fetchers/favourite/postFavouritePractitioner'
import { queryClient } from 'app/Root'
import { ApiQueryKeys } from 'constants/apiQueryKeys'

export const usePostFavouritePractitioner = createUseMutation({
  fetcher: postFavouritePractitioner,
  onSettled: async () => {
    await queryClient.invalidateQueries({ queryKey: [ApiQueryKeys.PRACTITIONERS] })
  },
})
